// extracted by mini-css-extract-plugin
module.exports = {"pageDescription":"RichText_pageDescription__x7XPy"};